import { formatCodeName } from '@atlas-frontend/sdk';
import { useMemo } from 'react';

export const useErrorReportDescriptionOptions = (
  errors: {
    dataObjectDescriptionCode: string;
    dataObjectDescriptionName: string;
  }[],
) =>
  useMemo(
    () =>
      [
        ...new Set(
          errors
            .filter(
              (e) => e.dataObjectDescriptionCode && e.dataObjectDescriptionName,
            )
            .map((e) =>
              formatCodeName({
                code: e.dataObjectDescriptionCode,
                name: e.dataObjectDescriptionName,
              }),
            ),
        ),
      ].map((name) => ({ id: name, name })),
    [errors],
  );
